import { render } from "./ExamAssignPatientOffcanvas.vue?vue&type=template&id=4796b1ba&scoped=true"
import script from "./ExamAssignPatientOffcanvas.vue?vue&type=script&lang=js"
export * from "./ExamAssignPatientOffcanvas.vue?vue&type=script&lang=js"

import "./ExamAssignPatientOffcanvas.vue?vue&type=style&index=0&id=4796b1ba&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4796b1ba"]])

export default __exports__